import api from '@/api'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import datepicker from 'vuejs-datepicker'
import { mapGetters } from 'vuex'
import NextCapitalAgentApprove from './NextCapitalAgentApprove.vue'
export default {
  props: {
    value: {
      default: null
    },
    loading: {
      default: true
    },
    livechat: {
      default: false
    },
    type: {
      default: 'edit'
    },
    isquickaddticket: {
      default: false
    },
    isEditAssigned: {
      default: false
    }
  },
  components: {
    Multiselect,
    datepicker,
    NextCapitalAgentApprove
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      agents: 'getAgent',
      loadingAgent: 'getLoadingAgent'
    }),
    filterSubGroup() {
      if (this.ticket.group) {
        return this.agentSubGroup.filter((el) => {
          return el.admingroupid == this.ticket.group.id
        })
      } else {
        return []
      }
    },
    filterAgents() {
      if (this.ticket.group) {
        let agents = this.agents
          ? this.agents.filter((el) => {
              return el.admingroupid == this.ticket.group.id
            })
          : []
        if (this.ticket.subgroup) {
          agents = agents
            ? agents.filter((el) => {
                return el.adminsubgroupid == this.ticket.subgroup.id
              })
            : []
        }
        return agents
      } else {
        return this.agents ? this.agents : []
      }
    }
  },
  data() {
    return {
      ticket: {
        userid: null,
        firstname: null,
        lastname: null,
        email: null,
        phoneno: null,
        group: null,
        subgroup: null,
        subject: null,
        details: null,
        assignedTo: null,
        app: null,
        channel: null,
        status: 'pending',
        gender: null,
        address: null,
        priority: null,
        duedate: null,
        tags: null,
        contact_firstname: null,
        contact_lastname: null,
        contact_salary: null,
        contact_occupation: null,
        contact_phone: null,
        contact_email: null,
        kfc_order_amount: null,
        satisfaction_score: null,
        suggestion_note: null,
        panel: [false]
      },
      loadingTicket: false,
      items: [],
      select: null,
      groupOptions: [],
      subGroupOptions: [],
      tags: [],
      tagitems: [{ header: 'Select an option or create one' }],
      tagediting: null,
      priority: {
        text: 'Medium',
        value: 'medium'
      },
      priorityOptions: [
        {
          text: 'Low',
          value: 'low'
        },
        {
          text: 'Medium',
          value: 'medium'
        },
        {
          text: 'High',
          value: 'high'
        }
      ],
      duedate: {
        start: null,
        starttime: null
      },
      selectedMenu: 'ticketInfo',
      dataAgentApprove: null,
      previousAssignGroupId: null
    }
  },
  async mounted() {
    if (this.value) {
      this.handleInitTicket()
    }

    this.cached_ticket = JSON.stringify(this.ticket)
  },
  watch: {
    value: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.handleInitTicket()
      }
    }
  },
  methods: {
    handleInitTicket() {
      this.ticket = {
        firstname: this.value.first_name,
        lastname: this.value.last_name,
        userid: this.value.userid,
        email: this.value.email,
        phoneno: this.value.phoneno,
        group: null,
        subgroup: null,
        subject: this.value.tickets[0][3],
        details: this.value.tickets[0][4],
        assignedTo: null,
        channel: this.value.tickets[0][7],
        status: this.value.tickets[0][2],
        id: this.value.tickets[0][0],
        orderid: this.value.tickets[0][19],
        priority: this.value.tickets[0][9],
        duedate: this.value.tickets[0][10],
        tags: this.value.tickets[0][11],
        contact_firstname: this.value.tickets[0][12],
        contact_lastname: this.value.tickets[0][13],
        contact_salary: this.value.tickets[0][14],
        contact_occupation: this.value.tickets[0][15],
        contact_phone: this.value.tickets[0][16],
        contact_email: this.value.tickets[0][17],
        kfc_order_amount: this.value.tickets[0][18],
        updateadminid: this.value.tickets[0][8],
        satisfaction_score: this.value.tickets[0][20],
        recommendation_score: this.value.tickets[0][21],
        suggestion_note: this.value.tickets[0][22]
      }
      if (this.value.tickets[0][10]) {
        this.duedate.start = this.value.tickets[0][10]
        this.duedate.starttime = moment(this.value.tickets[0][10]).format('HH:mm')
      }

      if (this.value.tickets[0][5]) {
        var group = this.agentGroup.find((el) => {
          return el.id == this.value.tickets[0][5]
        })
        if (group) this.$set(this.ticket, 'group', group)
      }
      if (this.value.tickets[0][6]) {
        var subgroup = this.agentSubGroup.find((el) => {
          return el.id == this.value.tickets[0][6]
        })

        if (subgroup) this.$set(this.ticket, 'subgroup', subgroup)
      }
      if (this.value.tickets[0][1]) {
        var agent = this.agents.find((el) => {
          return el.adminid == this.value.tickets[0][1]
        })
        if (agent) this.$set(this.ticket, 'assignedTo', agent)
      }

      if (this.value.tickets[0][9]) {
        this.priority = this.priorityOptions.find((el) => {
          return el.value == this.value.tickets[0][9]
        })
      }

      if (this.$store.state.oceanlifePage.includes(this.selectedBot.pageid)) {
        this.previousAssignGroupId = this.value.assigngroupid
      }

      try {
        if (this.value.tags) {
          var tags = this.value.tags.split(',')
          this.tags = tags.map((el) => {
            return { text: el }
          })
        }
      } catch (error) {
        console.error(error)
      }
    },
    onAssignInput(val) {
      if (val) {
        this.ticket.group = this.agentGroup.find((el) => el.id == val.admingroupid)
        this.ticket.subgroup = this.agentSubGroup.find((el) => el.id == val.adminsubgroupid)
      }
    },
    async onChangeGroup(val) {
      this.ticket.subgroup = null
      this.ticket.assignedTo = null
    },

    async onChangeSubGroup(val) {
      this.ticket.assignedTo = null
    },

    saveTicket(data) {
      return new Promise((resolve, reject) => {
        var request = data
        // console.log(request);
        api.postTickets(request, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    editTicket(data) {
      return new Promise((resolve, reject) => {
        var request = {
          data: data,
          params: {
            id: data.id,
            pageid: data.pageid
          }
        }
        api.putTickets(request, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    onCancelAssgined() {
      this.isEditAssigned = false
      this.ticket = JSON.parse(this.cached_ticket)
      this.select = null
      this.$emit('onCancelAssgined')
    },

    async onSave() {
      let result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      this.loadingTicket = true
      try {
        var data = {}
        data = {
          ...this.ticket,
          pageid: this.selectedBot.pageid,
          subject: this.ticket.subject,
          details: this.ticket.details,
          channel: this.ticket.channel,
          status: this.ticket.status,
          kfc_order_amount: this.ticket.kfc_order_amount,
          satisfaction_score: this.ticket.satisfaction_score,
          suggestion_note: this.ticket.suggestion_note,
          assigngroupid: this.ticket.group ? this.ticket.group.id : null,
          assignsubgroupid: this.ticket.subgroup ? this.ticket.subgroup.id : null,
          assignadminid: this.ticket.assignedTo ? this.ticket.assignedTo.adminid : null,

          priority: this.priority.value,
          duedate: this.duedate.start
            ? moment(this.duedate.start).format('YYYY-MM-DD ') +
              (this.duedate.starttime ? this.duedate.starttime : '00:00')
            : null,
          tags: this.tags
            .map((el) => {
              return el.text
            })
            .join(',')
        }

        if (this.$store.state.oceanlifePage.includes(this.selectedBot.pageid)) {
          if (this.previousAssignGroupId !== this.ticket.group.id) {
            data.previous_assigngroupid = this.previousAssignGroupId
          }
        }

        var responseTicket = await this.editTicket(data)

        if (data.status == 'closed') {
          this.$store.dispatch('loadLatestUsers', {
            type: this.$store.state.livechat.type
          })
        }
        this.$emit('editTicket', responseTicket.data[0])

        this.isEditAssigned = false
        this.cached_ticket = JSON.stringify(this.ticket)
        this.select = null
      } catch (error) {
        console.error(error)
      }
      this.loadingTicket = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/template/ticket/ManageTicketLiveChat.js